// extracted by mini-css-extract-plugin
export default {"wrapper":"saa-z","boldPrefix":"taa-z","link":"uaa-z","message":"vaa-z","image":"waa-z"};